<template>
  <div class="tml-bubble inline-flex justify-center items-center w-10 h-10 overflow-hidden">
    <slot />
  </div>
</template>

<style scoped>
.tml-bubble {
  @apply bg-[--tml-bubble-background-color];
  @apply rounded-[--tml-bubble-radius];
  @apply border-[length:--tml-bubble-border-width] border-[--tml-bubble-border-color];
}
</style>
